export const Roles = {
  ADMIN: "admin",
  TMM: "tmm",
  TDR: "tdr",
  CLIENT: "client",
  CLIENTMANAGER: "clientManager",
  AGENTMANAGER: "agentManager",
  PARTNER: "partner",
  RIDER: "rider",
  FULFILMENTPROVIDER: "fulfillmentProvider"
};
